if (!customElements.get('header-hamburger')) {
  class HeaderHamburger extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const mobileMenu = document.querySelector('mobile-menu');
      if (!mobileMenu) return;

      this.addEventListener('click', () => {
        const isOpen = this.toggleAttribute('data-open');
        mobileMenu.toggleAttribute('data-open', isOpen);
        document.body.style.overflow = isOpen ? 'hidden' : '';

        if (isOpen) {
          const header = document.querySelector('.sticky-header');
          const headerHeight = header ? header.getBoundingClientRect().height : 0;
          const modal = mobileMenu.querySelector('[data-modal]');
          if (modal) {
            modal.style.top = headerHeight + 'px';
            modal.style.height = `calc(100% - ${headerHeight}px)`;
          }
        }
      });
    }
  }

  customElements.define('header-hamburger', HeaderHamburger);
}

if (!customElements.get('mobile-menu')) {
  class MobileMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Close menu when clicking on overlay
      this.addEventListener('click', (e) => {
        if (e.target === this) {
          const hamburger = document.querySelector('header-hamburger');
          if (hamburger) {
            hamburger.removeAttribute('data-open');
            this.removeAttribute('data-open');
            document.body.style.overflow = '';
          }
        }
      });
    }
  }
  customElements.define('mobile-menu', MobileMenu);
}

if (!customElements.get('desktop-menu')) {
  class DesktopMenu extends HTMLElement {
    constructor() {
      super();
      this.closeTimeout = null;
      this.currentScrollTop = 0;
    }

    connectedCallback() {
      this.initializeDropdowns();
      this.setupEventListeners();
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    // Initialize dropdown positioning based on header height
    initializeDropdowns() {
      this.links = document.querySelectorAll('[data-has-dropdown]');
      this.dropdowns = this.querySelectorAll('[data-dropdown]');
    }

    // Setup hover event listeners for links and dropdowns
    setupEventListeners() {
      this.links.forEach((link, index) => {
        link.addEventListener('mouseenter', () => this.showDropdown(link, index));
        link.addEventListener('mouseleave', () => this.scheduleHideDropdown(link, index));
      });

      this.dropdowns.forEach((dropdown, index) => {
        dropdown.addEventListener('mouseenter', () => this.cancelHideDropdown());
        dropdown.addEventListener('mouseleave', () => this.scheduleHideDropdown(this.links[index], index));
      });
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Hide dropdowns when scrolling down or up
      if (Math.abs(scrollTop - this.currentScrollTop) > 5) {
        this.hideAllDropdowns();
      }

      this.currentScrollTop = scrollTop;
    }

    // Show dropdown for specific link
    showDropdown(activeLink, index) {
      this.cancelHideDropdown();
      this.hideAllDropdowns();

      const header = document.querySelector('.sticky-header');
      const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      this.style.top = headerBottom + 'px';

      this.setAttribute('data-open', '');
      activeLink.setAttribute('data-open', '');
      this.dropdowns[index].setAttribute('data-open', '');
    }

    // Hide all active dropdowns and links
    hideAllDropdowns() {
      this.removeAttribute('data-open');
      this.links.forEach(link => link.removeAttribute('data-open'));
      this.dropdowns.forEach(dropdown => dropdown.removeAttribute('data-open'));
    }

    // Schedule dropdown hiding with small delay for smooth UX
    scheduleHideDropdown(link, index) {
      this.closeTimeout = setTimeout(() => {
        this.removeAttribute('data-open');
        link.removeAttribute('data-open');
        this.dropdowns[index].removeAttribute('data-open');
      }, 100);
    }

    // Cancel scheduled dropdown hiding
    cancelHideDropdown() {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
    }
  }
  customElements.define('desktop-menu', DesktopMenu);
}
